import { Component, HostListener, NgZone, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItem } from 'src/app/models/menu-item';
import { ItemMenuService } from '../../services/item-menu.service';
import { InitializationService } from '../../services/initialization.service';
import { CurrentOrderService } from '../../services/current-order.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DetailGroupPack } from 'src/app/models/detail-group-pack';
import { Detail } from 'src/app/models/detail';
import { MenuItemHolder } from 'src/app/holders/menu-item-holder';
import { NavigationService } from 'src/app/services/navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';
import { InputDialogComponent } from '../dialogs/input-dialog/input-dialog.component';
import { StepperDialogComponent } from '../dialogs/stepper-dialog/stepper-dialog.component';
import { LocaleService } from 'src/app/services/locale.service';
import { Platform } from '@angular/cdk/platform';
import { MatRipple } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { OrderTypePickerDialogComponent } from '../dialogs/order-type-picker-dialog/order-type-picker-dialog.component';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { WorkWeekService } from 'src/app/services/work-week.service';
import { SummaryDialogComponent } from '../dialogs/summary-dialog/summary-dialog.component';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { subscribe as KeyboardDetector } from 'on-screen-keyboard-detector';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit
{
  @ViewChild('bottomBar', { read: MatRipple })
  ripple?: MatRipple;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  itemHolder:MenuItemHolder = new MenuItemHolder();
  currentPriceString:string = '';
  canSave:boolean = false;
  canPop:boolean = false;
  rippleColor:string = "#FFFFFF25";

  showAddButton:boolean = true;

  status:string='new';
  isClosed:boolean = false;

  isRedirect:boolean = false;
  itemLink:string = '';
  isError:boolean = false;

  jumpedGroups:Array<string> = Array<string>();
  lastRippleDone:boolean = false;

  showBottomBar=true;

  constructor(
    private itemmenuservice:ItemMenuService, 
    private initializationservice:InitializationService, 
    private route: ActivatedRoute, 
    private currentorderservice:CurrentOrderService,
    private navigationservice:NavigationService,
    public alertDialog: MatDialog,
    private localeservice:LocaleService,
    public platform: Platform,
    private _snackBar: MatSnackBar,
    private router:Router,
    private ngzone: NgZone,
    private currentinfoservice: CurrentInfoService,
    private workweekservice: WorkWeekService,
    private pixelservice: AnalyticsService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    this.isClosed = !(this.workweekservice.isOpen() && this.currentinfoservice.isOpen());

    var itemuid = String(this.route.snapshot.paramMap.get('menuitemuid'))

    this.itemLink = `${window.location.origin}/${appname}/direct/item/${itemuid}`;

    this.isRedirect = String(this.route.snapshot.queryParamMap.get('isredirect')) === 'true';

    this.status = String(this.route.snapshot.queryParamMap.get('status'));

    if(this.status === 'new')
      this.itemHolder = this.itemmenuservice.getMenuItemHolder(itemuid);

    if(this.status === 'edit')
      this.itemHolder = this.currentorderservice.getItem(itemuid);

    if(this.itemHolder.MenuItem.UniversalID.length === 0)
    {
      this.isError = true;

      return;
    }

    this.updateCurrentPrice();

    setTimeout(() => this.updateCanSave(), 300);

    KeyboardDetector(visibility => { this.showBottomBar = visibility === "hidden"; });
  }

  ngAfterViewInit() : void
  {
    this.setStickyTop();
  }

  setStickyTop()
  {
    var topbar = document.getElementById("topbar");

    if(topbar)
    {
      for (let index = 0; index < this.itemHolder.DetailGroupPacks.length; index++) 
      {
        const detailPack = this.itemHolder.DetailGroupPacks[index];
        
        var element = document.getElementById(detailPack.DetailGroup.ID);

        if(element)
          element.style.top = `${topbar.offsetHeight}px`;
      }
    }
  }

  countTap(amount:number)
  {
    if(amount === 0)
    {
      let dialogRef = this.alertDialog.open(InputDialogComponent, {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Detail"),
          accept:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Accept"),
          cancel:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Cancel"), 
          content: String(this.itemHolder.MenuItem.ItemCount) 
        }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        if(result !== null && result != undefined && result !== '')
        {
          var newCount = Number(result);

          if(newCount !== null && newCount !== undefined)
          {
            if(newCount < 1)
              newCount = 1;

            this.itemHolder.MenuItem.ItemCount = newCount;

            this.updateCurrentPrice();
          }
        }
      });

      return;
    }

    this.itemHolder.MenuItem.ItemCount += amount;

    if(this.itemHolder.MenuItem.ItemCount < 1)
      this.itemHolder.MenuItem.ItemCount = 1;

    this.updateCurrentPrice();
  }

  back()
  {
    this.navigationservice.back();
  }

  async canReturn()
  { 
    if(this.isError)
      return true;

    if(this.canPop === true)
      return true;

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
      return true;

    return new Promise<boolean>((resolve, reject) =>
    {
      let dialogRef = this.alertDialog.open(AlertDialogComponent, {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Accept"), 
          cancel:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Cancel")  
        }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        if(result === true)
        {
          if(this.isRedirect)
          {
            this.canPop = true;
    
            this.goHome()
    
            resolve(false);
          }
          else
            resolve(true);
        }
        else
          resolve(false);
      });
    });
  }

  detailTap(detail:Detail, detailGroupPack:DetailGroupPack)
  {
    if(detailGroupPack.DetailGroup.LimitMacroSelection && detail.Type === 0 && detail.CurrentCount === 0 && this.itemHolder.isMacroMaxedOut(detailGroupPack.DetailGroup.MacroID))
    {  
      this.showMaxOptionsWarning();

      return;
    }

    if(detailGroupPack.DetailGroup.LimitSelection && detail.Type === 0 && detail.CurrentCount === 0 && detailGroupPack.isMaxedOut())
    {
      this.showMaxOptionsWarning();

      return;
    }


    if(detail.MaxCount > 1)
    {
      var max = detail.MaxCount;

      if(detailGroupPack.DetailGroup.LimitMacroSelection || detailGroupPack.DetailGroup.LimitSelection)
      {
        var remaining = detailGroupPack.getRemainingSelections(this.itemHolder.getMacroSelectionCount(detailGroupPack.DetailGroup.MacroID));

        if(max > remaining)
          max = remaining + detail.CurrentCount;
        
        if(detailGroupPack.isMaxedOut())
          max = detail.CurrentCount;
      }

      let dialogRef = this.alertDialog.open(StepperDialogComponent, {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        {  
          title:detail.Name, 
          detail: `${this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Detail")}(Max:${max})`, 
          count:detail.CurrentCount, 
          maxcount:max,
          accept:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Accept"),
          cancel:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Cancel"),
         }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        if(result !== null && result != undefined && result !== '')
        {
          var newCount = Number(result);

          if(newCount !== null && newCount !== undefined)
          {
            var status =  detailGroupPack.detailTap(detail, newCount, this.itemHolder.getMacroSelectionCount(detailGroupPack.DetailGroup.MacroID));
            
            if(status)
            {
              this.updateLimitSelectionDescription(detailGroupPack);

              this.updateCurrentPrice();

              this.updateCanSave();

              setTimeout(() => this.goToNextDetailGroup(detailGroupPack), 175);
            }
          }
        }
      });
    }
    else
    {
      var status = detailGroupPack.detailTap(detail);

      if(status)
      {
        this.updateLimitSelectionDescription(detailGroupPack);

        this.updateCurrentPrice();

        this.updateCanSave();

        setTimeout(() => this.goToNextDetailGroup(detailGroupPack), 175);
      }
    }
  }

  showMaxOptionsWarning()
  {
    this.alertDialog.open(AlertDialogComponent, 
    {
      height: 'fit-content',
      width: 'fit-content',
      data: 
      { 
        title: this.localeservice.instantTranslation("Dialogs.Alert.MaxOptionCount.Title"),
        detail:this.localeservice.instantTranslation("Dialogs.Alert.MaxOptionCount.Detail"), 
        accept:this.localeservice.instantTranslation("Dialogs.Alert.MaxOptionCount.Accept") 
      }
    });
  }

  updateLimitSelectionDescription(detailGroupPack:DetailGroupPack)
  {
    var macroPacks = this.itemHolder.getMacroPacks(detailGroupPack.DetailGroup.MacroID);

    if(macroPacks.length > 0)
    {
      var macroCount = 0;

      for (let index = 0; index < macroPacks.length; index++) 
      {
          const element = macroPacks[index];
          
          macroCount += element.getSelectionCount();
      }

      for (let index = 0; index < macroPacks.length; index++) 
      {
        const element = macroPacks[index];
        
        element.updateLimitSelectionDescription(macroCount, detailGroupPack.DetailGroup.MacroMinSelectionCount);
      }
    }
    else
      detailGroupPack.updateLimitSelectionDescription();
  }

  showList(detailGroupPack:DetailGroupPack, show:boolean)
  {
    if(show === true)
    {
      this.itemHolder.DetailGroupPacks.forEach(x => x.ShowList = x.DetailGroup.ID === detailGroupPack.DetailGroup.ID);

      setTimeout(() =>
      {
        var element = document.getElementById(detailGroupPack.DetailGroup.ID);

        if(element)
          this.scrollTo(element);
      }, 150);
    }
    else
      detailGroupPack.ShowList = false;
  }

  goToNextDetailGroup(currentDetailGroup:DetailGroupPack)
  {
    if(!this.jumpedGroups.find(x => x === currentDetailGroup.DetailGroup.ID) && (currentDetailGroup.isMaxedOut() && !currentDetailGroup.HasDefault() || (currentDetailGroup.DetailGroup.LimitMacroSelection && this.itemHolder.isMacroMaxedOut(currentDetailGroup.DetailGroup.MacroID))))
    {
      var currentGroupIndx = this.itemHolder.DetailGroupPacks.findIndex(x => x.DetailGroup.ID == currentDetailGroup.DetailGroup.ID);

      if(currentGroupIndx > -1 && this.itemHolder.DetailGroupPacks.length -1 > currentGroupIndx)
      {
        var nextGroupPack = this.itemHolder.DetailGroupPacks[currentGroupIndx + 1];

        if(nextGroupPack.isMaxedOut() && !nextGroupPack.HasDefault() || (nextGroupPack.DetailGroup.LimitMacroSelection && this.itemHolder.isMacroMaxedOut(nextGroupPack.DetailGroup.MacroID)))
        {
          this.goToNextDetailGroup(nextGroupPack);

          return;
        }
        
        this.showList(nextGroupPack, true);

        this.jumpedGroups.push(currentDetailGroup.DetailGroup.ID);
      }
      else if(this.lastRippleDone === false)
      {
        this.lastRippleDone = true;

        if(this.itemHolder.DetailGroupPacks.length > 0)
          this.fireBottomRipple();
      }
    }
  }

  scrollTo(element:HTMLElement)
  {
    var topbar = document.getElementById("topbar");

    if(topbar)
    {
      var bounds = element.getBoundingClientRect();

      window.scrollTo(
        {
          top: bounds.top + window.scrollY - topbar.offsetHeight,
          behavior: "smooth"
        });
    }
  }

  updateCurrentPrice()
  {
    this.currentPriceString = this.localeservice.getCurrencyString(this.itemHolder.CurrentPrice);
  }

  updateCanSave()
  {
    var before = this.canSave;

    this.canSave = this.itemHolder.getValidation() === true && this.itemHolder.checkMacro() === true;

    if(before != this.canSave && this.canSave === true)
      this.fireBottomRipple();
  }

  save()
  {
    if(this.canSave === true)
    {
      if(this.isRedirect)
      {
        var dialRef = this.alertDialog.open(
          OrderTypePickerDialogComponent, 
          {
            height: 'fit-content',
            width: '90vw'
          });

          dialRef.afterClosed().subscribe((r) =>
          {
            if(r === 'done')
            {
              this.ngzone.run(() =>
                {
                  this.currentorderservice.addItem(this.itemHolder);

                  this.pixelservice.facebookTrack('AddedToOrder', { name: this.itemHolder.Name, id: this.itemHolder.UniversalID } );

                  this.canPop = true;

                  var appname = String(this.route.snapshot.paramMap.get('appname'));

                  this.router.navigateByUrl('/' + appname + '/menuitens?isredirect=true', { replaceUrl:true });
                });
            }
          })

          return;
      }

      if(this.status === 'new')
      {
        this.currentorderservice.addItem(this.itemHolder);

        this.pixelservice.facebookTrack('AddedToOrder', { name: this.itemHolder.Name, id: this.itemHolder.UniversalID } );

        this.canPop = true;

        this.back();
      }

      if(this.status === 'edit')
      {
        var result = this.currentorderservice.saveItem(this.itemHolder);

        if(result === true)
        {
          this.canPop = true;

          this.back();
        }
        else
        {
          this.alertDialog.open(AlertDialogComponent, 
          {
            height: 'fit-content',
            width: 'fit-content',
            data: 
            { 
              title: this.localeservice.instantTranslation("Dialogs.Alert.ItemSaveError.Title"),
              detail:this.localeservice.instantTranslation("Dialogs.Alert.ItemSaveError.Detail"), 
              accept:this.localeservice.instantTranslation("Dialogs.Alert.ItemSaveError.Accept") 
            }
          });
        }
      }
    }
  }

  fireBottomRipple()
  {
    if(this.ripple)
    {
      const rippleRef = this.ripple.launch({ persistent: true, centered:true });
      
      setTimeout(() => rippleRef.fadeOut(), 1000);
    }
  }

  copyLink()
  {
    this._snackBar.open("Link Copiado", undefined, { duration:2000 });
  }

  showWorkTime()
  {
    this.alertDialog.open(SummaryDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title: this.localeservice.instantTranslation("Dialogs.Summary.WorkTimeSummary.Title"), 
          detail:this.workweekservice.getWorkWeekSummary(), 
          accept:this.localeservice.instantTranslation("Dialogs.Summary.WorkTimeSummary.Accept") 
        }
      });
  }

  goHome()
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));
      
    this.router.navigateByUrl('/' + appname);
  }
}